<template>
  <main :class="$options.name">
    <Head
      :title="$options.name + ' | Nice Bike'"
      description="We are a family owned small bicycle shop that is dedicated to bringing you the absolute best in cycling. We are Nice Bike."
      keywords="nice bike"
      image="https://ridenicebike.com/img/social.jpg"
      url="https://ridenicebike.com"
    />
    <article class="Box innerWrap">
      <h1>Thanks for your message!</h1>
      <hr>
      <p>We’re so happy you reached out, we’ll follow-up soon!</p>
      <Button label="Go home" path="/"/>
    </article>
  </main>
</template>
<script>
import Button from "@/components/Button";
export default {
  name: "Thanks",
  components: { Button }
};
</script>
<style lang="scss">
.Thanks {
  .Box {
    max-width: rem(640);
    text-align: center;
  }
}
</style>